import React, { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const { user } = useAuth();
  const hasPassword = user?.has_password !== false;
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const reset = () => { setCurrent(""); setNext(""); setConfirm(""); };

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) { toast.error("A nova senha deve ter pelo menos 6 caracteres."); return; }
    if (next !== confirm) { toast.error("As senhas não conferem."); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", {
        current_password: hasPassword ? current : undefined,
        new_password: next,
      });
      toast.success("Senha alterada com sucesso!");
      reset();
      onOpenChange(false);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { onOpenChange(o); if (!o) reset(); }}>
      <DialogContent className="max-w-sm" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle>Trocar senha</DialogTitle>
          <DialogDescription>
            {hasPassword ? "Informe a senha atual e a nova senha." : "Defina uma senha para sua conta."}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          {hasPassword && (
            <div className="space-y-1.5">
              <Label htmlFor="cur-pass">Senha atual</Label>
              <Input id="cur-pass" type="password" required value={current}
                onChange={(e) => setCurrent(e.target.value)} data-testid="current-password-input" />
            </div>
          )}
          <div className="space-y-1.5">
            <Label htmlFor="new-pass">Nova senha</Label>
            <Input id="new-pass" type="password" required value={next}
              onChange={(e) => setNext(e.target.value)} placeholder="Mínimo 6 caracteres"
              data-testid="new-password-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="conf-pass">Confirmar nova senha</Label>
            <Input id="conf-pass" type="password" required value={confirm}
              onChange={(e) => setConfirm(e.target.value)} data-testid="confirm-password-input" />
          </div>
          <DialogFooter>
            <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700"
              disabled={busy} data-testid="submit-change-password-button">
              {busy ? "Salvando..." : "Salvar nova senha"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
